"use client";

export default function BackgroundVideo() {
  return (
    <>
      {/* Gradient animado como base/fallback */}
      <div
        className="animated-background"
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          zIndex: 0,
          overflow: "hidden",
          pointerEvents: "none",
        }}
      />

      {/* Video encima del gradient */}
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          zIndex: 0,
          overflow: "hidden",
          pointerEvents: "none",
        }}
      >
        <video
          autoPlay
          muted
          loop
          playsInline
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            filter: "brightness(0.9)",
          }}
        >
          <source src="/hero-video.mp4" type="video/mp4" />
        </video>
        {/* Overlay oscuro */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0, 0, 0, 0.6)",
            backdropFilter: "blur(1px)",
            pointerEvents: "none",
          }}
        />
      </div>
    </>
  );
}
